/**
 * Database operation values
 */
export enum DatabaseOperationEnum {
	INSERT = 'insert',
	UPDATE = 'update',
	DELETE = 'delete',
	LINKED = 'linked',
	UNLINKED = 'unlinked',
	STATUS_CHANGED = 'status_changed',
}
